<!-- <formio-loader></formio-loader> -->

<div class="app-resource-dropdown-wrapper">
	<div *ngIf="viewOnly; else showSelect" class="displayAsInput">
		<ng-container *ngIf="displayValue; else empty">
			<ng-container *ngIf="customOptions?.disabledValueTranslation; else checkResource">
				{{ displayValue | translate }}
			</ng-container>
			<ng-template #checkResource>
				<ng-container *ngIf="isSelectedResourceDisabledValueTranslation; else showValue">
					{{ displayValue }}
				</ng-container>
				<ng-template #showValue>
					{{ 'forms.common.' + displayValue | translate }}
				</ng-template>
			</ng-template>
		</ng-container>
		<ng-template #empty> - </ng-template>
	</div>
	<ng-template #showSelect>
		<div
			id="resources-list-container-{{randomId}}"
			class="choices form-group formio-choices resources-list-container"
			data-type="select-one"
			[dir]="dir"
		>
			<div class="form-control" (click)="isOpened = !isOpened">
				<select class="form-control choices__input is-hidden"></select>

				<div class="choices__list choices__list--single" *ngIf="value">
					<div class="choices__item choices__item--selectable">
						<ng-container *ngIf="customOptions?.disabledValueTranslation; else checkResource">
							<span>{{ displayValue | translate }}</span>
						</ng-container>
						<ng-template #checkResource>
							<ng-container *ngIf="isSelectedResourceDisabledValueTranslation; else showValue">
								<span>{{ displayValue | translate }}</span>
							</ng-container>
							<ng-template #showValue>
								<span>{{ 'forms.common.' + displayValue | translate }}</span>
							</ng-template>
						</ng-template>

						<button type="button" class="choices__button" *ngIf="!disabled" (click)="clearValue()">
							Remove item
						</button>
					</div>
				</div>
			</div>

			<div class="choices__list choices__list--dropdown {{ isOpened ? 'is-active' : '' }}">
				<input
					type="text"
					class="choices__input choices__input--cloned"
					placeholder="{{ 'forms.common.Search' | translate }}"
					[value]="filter"
					[formControl]="filterControl"
				/>

				<div class="list-of-resources">
					<ng-container *ngFor="let res of resources; let resourceIndex = index">
						<div class="list">
							<label *ngIf="res.label">{{ 'forms.common.' + res.label | translate }}</label>

							<div
								class="choices__list {{ res.grid ? 'gridContainer' : '' }}"
								dir="ltr"
								infinite-scroll
								[scrollWindow]="false"
								[infiniteScrollThrottle]="0"
								[infiniteScrollDistance]="2"
								(scrolled)="onScrollDown($event, resourceIndex)"
							>
								<div
									*ngFor="let item of res.data"
									(click)="selectItem(res.key, item)"
									class="item choices__item choices__item--choice choices__item--selectable"
									[ngClass]="{ 'selected-item': value?.selectedItem?._id == item._id }"
								>
									<span *ngIf="res.displayField; else showValue">
										<ng-container *ngIf="res.displayField?.translatable; else showNormal">
											{{ 'forms.common.' + item.data[res.displayField?.key] | translate }}
										</ng-container>
										<ng-template #showNormal>
											{{ item.data[res.displayField?.key] }}
										</ng-template>
									</span>
									<ng-template #showValue>
										<span>
											{{ 'forms.common.' + item.data.value | translate }}
										</span>
									</ng-template>
								</div>
							</div>

							<div class="loader-container" *ngIf="currentResourceLoading == resourceIndex">
								<div class="loader"></div>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</ng-template>
</div>
